import directorChairIcon from "./director-chair_icon.svg";
import builingIcons from "./builing_icon.svg";
import saveIcons from "./save_icon.svg";
import locationIcons from "./location_icon.svg";
import navigateIcons from "./navigate_icon.svg";
import rollFanIcons from "./fans.svg";
import rollTALENTIcons from "./talent-search_icon.svg";
import rollPARTNERIcons from "./Layer 2.svg";
import rollAGENCYIcons from "./g3159.svg";
import rollEMYIcons from "./businessman.svg";
import rollVendercons from "./enterpreneur.svg";
import hidePasswordIcon from "./hidePassword_icon.svg";
import showPasswordIcon from "./showPasswordIcon.svg";
import googleIcon from "./google_icon.svg";
import calendarIcon from "./calendarIcon.svg";
import documentIcon from "./documentIcon.svg";
import LiveIcon from "./live_Icon.svg";
import LiveActitveIcon from "./like_active_icon.svg";
import favIcon from "./favIcon.svg";
import favAvtiveIcon from "./fav_active_icon.svg";
import pointsIcon from "./points_icon.svg";
import submitIcon from "./submit_icons.svg";
import jobDetailAgencyIcon from "./jobDetail_Agency_icon.svg";
import cvfileIcon from "./FILES_AND FOLDER_icon.svg";
import pdfIcon from "./pdf_icon.svg";
import BookaTalentIcon from "./BookaTalent_icon.svg";
import SellYourServicesIcon from "./Sell Your Services_icon.svg";
import CreativeCollaborationsIcon from "./Creative Collaborations_icpon.svg";
import PitchYourFilmProjectsIcon from "./Pitch Your Film Projects_icon.svg";
import SignTalentCreatorsIcon from "./Sign Talent & Creators_icon.svg";
import SupportNewTalentIcon from "./Support New Talent_icon.svg";
import Saved_JobIcon from "./Saved_Job_icon.svg";
import dashboardIcon from "./dashboard_icon_menu.svg";
import dashboardActiveIcon from "./dashboard_active_icon_menu.svg";
import TeamIcon from "./team_menu_icon.svg";
import TeamActiveIcon from "./team_menu_active_icon.svg";
import PackagesIcon from "./packages_menu_icon.svg";
import PackagesActiveIcon from "./packages_menu_avtive_icon.svg";
import NewsIcon from "./news_menu_icon.svg";
import NewsActiveIcon from "./news_menu_Active_icon.svg";
import EventIcon from "./events_menu_icon.svg";
import EventActiveIcon from "./events_menu_active_icon.svg";
import TalentIcon from "./talents_menu_icon.svg";
import TalentActiveIcon from "./talents_menu_active_icon.svg";
import ProjectIcon from "./projects_menu_icon.svg";
import ProjectActiveIcon from "./projects_menu_active_icon.svg";
import adimIcon from "./user_icon.svg";
import searchIcon from "./search_icon.svg";
import userPlusIcon from "./userPlus_icon.svg";
import HiringRequestIcon from "./hiring_request_icon.svg";
import JobsAppliedIcon from "./jobs_applied_ionc.svg";
import EventsParticipatedIcon from "./mobilization.svg";
import FavouritesIcon from "./bookmark.svg";
import TotalSharesIcon from "./network.svg";
import uploadIcon from "./Upload.svg";
import arrowIcon from "./arrow_icons.svg";
import requestApprovedIcon from "./Request Approved_icon.svg";
import requestRejectedIcon from "./Request Rejected_icon.svg";
import chatIcon from "./chat_icon.svg";
import favEventIcon from "./favEvent_icon.svg";
import favNewsIcon from "./favNewz_icon.svg";
import favJobsIcon from "./favJobs_icon.svg";
import chatmessageIcon from "./message_menu_icon.svg";
import chatmessageActiveIcon from "./message_menu_active_icon.svg";
import settingIcon from "./setting_icon.svg";
import settingActiveIcon from "./setting_active_icon.svg";
import dashboardHomeIcon from "./dashboard_home_Icon.svg";
import notificationInactiveIcon from "./notification_dashboard_icon.svg";
import notificationEmptyIcon from "./notification_dashboard_Unavailable_icon.svg";
import emailDashboardIcon from "./email_dashboard_icon.svg";
import memberPerksIcon from "./memberPerks_icon.svg";
import favouritesIcon from "./favourites_icon.svg";
import rewardPointsIcon from "./reward_points_icon.svg";
import totalReferralsIcon from "./total_referralsIcon_icon.svg";
import activitybtnIcon from "./activitybtn_Icon.svg";
import dasSaveIcon from "./dasSave_icon.svg";
import dasSavedIcon from "./dasSaved_icon.svg";
import tableTitleIcon from "./tableTitle_icon.svg";
import paginationIcon from "./pagination_icon.svg";
import powerLogoutIcon from "./power_logout_icon.svg";
import messageSettingIcon from "./message_Setting_Icon.svg";
import messageEditIcon from "./message_Edit_Icon.svg";
import informationIcon from "./information_Icon.svg";
import messageSendIcon from "./message_send_icon.svg";
import jobviewsCountesIcon from "./job_views_Countes_Icon.svg";
import jobappliedCountIcon from "./job_applied_Count_Icon.svg";
import favoritesCountIcon from "./favorites_CountI_Icon.svg";
import binIcon from "./bin_icon.svg";
import editIcon from "./edit_icon.svg";
import ProfileEditIcon from "./Profile_edit_Icon.svg";
import onErrorIcon from "./onError_icon.svg";
import onSuccessIcon from "./onSuccess_icon.svg";
import LikeIcon from "./like_icon.svg";
import disLikeIcon from "./disLike_icon.svg";
import galleryMenuIcon from "./gallery_menu_icons.svg";
import galleryMenuActiveIcon from "./gallery_menu__active_icons.svg";
import hero_imageEditeIcons from "./hero_imageEdite_Icons.svg";
import uploadProjectIcon from "./uploadProject_Icon.svg";
import filtersIcons from "./filter_icon.svg";
import joblistingFiltersIcons from "./joblisting_filter_icon.svg";
import plusIcon from "./plus_icon.svg";
const Icons = {
  directorChairIcon,
  builingIcons,
  saveIcons,
  locationIcons,
  navigateIcons,
  rollFanIcons,
  rollTALENTIcons,
  rollAGENCYIcons,
  rollPARTNERIcons,
  rollEMYIcons,
  rollVendercons,
  hidePasswordIcon,
  showPasswordIcon,
  googleIcon,
  calendarIcon,
  documentIcon,
  LiveIcon,
  LiveActitveIcon,
  favIcon,
  favAvtiveIcon,
  pointsIcon,
  submitIcon,
  jobDetailAgencyIcon,
  cvfileIcon,
  pdfIcon,
  BookaTalentIcon,
  SellYourServicesIcon,
  CreativeCollaborationsIcon,
  PitchYourFilmProjectsIcon,
  SignTalentCreatorsIcon,
  SupportNewTalentIcon,
  Saved_JobIcon,
  dashboardIcon,
  dashboardActiveIcon,
  TeamIcon,
  TeamActiveIcon,
  PackagesIcon,
  PackagesActiveIcon,
  NewsIcon,
  NewsActiveIcon,
  EventIcon,
  EventActiveIcon,
  TalentIcon,
  TalentActiveIcon,
  ProjectIcon,
  ProjectActiveIcon,
  adimIcon,
  searchIcon,
  userPlusIcon,
  HiringRequestIcon,
  JobsAppliedIcon,
  EventsParticipatedIcon,
  FavouritesIcon,
  TotalSharesIcon,
  uploadIcon,
  arrowIcon,
  requestApprovedIcon,
  requestRejectedIcon,
  chatIcon,
  favJobsIcon,
  favNewsIcon,
  favEventIcon,
  chatmessageIcon,
  chatmessageActiveIcon,
  settingActiveIcon,
  settingIcon,
  dashboardHomeIcon,
  notificationInactiveIcon,
  notificationEmptyIcon,
  emailDashboardIcon,
  memberPerksIcon,
  favouritesIcon,
  rewardPointsIcon,
  totalReferralsIcon,
  activitybtnIcon,
  dasSaveIcon,
  dasSavedIcon,
  tableTitleIcon,
  paginationIcon,
  powerLogoutIcon,
  messageSettingIcon,
  messageEditIcon,
  informationIcon,
  messageSendIcon,
  jobappliedCountIcon,
  jobviewsCountesIcon,
  favoritesCountIcon,
  binIcon,
  editIcon,
  ProfileEditIcon,
  onErrorIcon,
  onSuccessIcon,
  LikeIcon,
  disLikeIcon,
  galleryMenuIcon,
  galleryMenuActiveIcon,
  hero_imageEditeIcons,
  uploadProjectIcon,
  filtersIcons,
  joblistingFiltersIcons,
  plusIcon,
};
export default Icons;
